import { BehaviorSubject } from "rxjs";

// Admin-only "Show all companies" toggle. The API ignores scope=all for non-admins.
const storageKey = 'showAllCompanies';

function readStored() {
    try {
        return localStorage.getItem(storageKey) === 'true';
    } catch {
        return false;
    }
}

const showAllCompaniesSubject = new BehaviorSubject<boolean>(readStored());

export const companyScopeService = {
    setShowAllCompanies,
    showAllCompanies: showAllCompaniesSubject.asObservable(),
    get showAllCompaniesValue() { return showAllCompaniesSubject.value },
};

function setShowAllCompanies(value: boolean) {
    try {
        localStorage.setItem(storageKey, String(value));
    } catch {
        // Preference just won't persist
    }
    showAllCompaniesSubject.next(value);
}

// Appends scope=all to a URL when the toggle is on
export function withCompanyScope(url: string) {
    if (!showAllCompaniesSubject.value) {
        return url;
    }

    return `${url}${url.includes('?') ? '&' : '?'}scope=all`;
}
